import { type Category, type CategoryProps, mkCategory } from './categoriesTypes';

export const transformClientResourceToRequestData = (category: Category | CategoryProps) => ({
  id: category.id,
  clientId: category.clientId,
  parentClientId: category.parentClientId,
  parentId: category.parentId,

  categoryType: category.type,
  name: category.name,
  description: category.description,

  usageType: category.usageType,

  isExcludedFromBudgets: category.isExcludedFromBudgets,
  isExcludedFromCategoryList: category.isExcludedFromCategoryList,
  isExcludedFromReports: category.isExcludedFromReports,

  txfId: category.txfId,
  txfIds: category.txfIds,

  isDeleted: category.isDeleted,
});

export const transformServerResourceToClientResource = (data: CategoryProps) =>
  mkCategory({
    ...data,
    type: data.categoryType,
    usageType: transformApiUsageType(data.usageType),
  });

const transformApiUsageType = (usageType?: string) => {
  if (usageType !== 'PERSONAL' && usageType !== 'BUSINESS' && usageType !== 'RENTAL' && usageType !== 'FARMING') {
    return 'PERSONAL';
  }
  return usageType;
};
